/**
 * `progress` — measured: monday offers exactly **two** rows on a progress-tracking column,
 * `is` and `is not`, over the tracked statuses. Our round-3 list offered none at all, so a
 * progress column could not be filtered.
 */
import { IS_NOT_ONE_OF, IS_ONE_OF } from '../filter-conditions.js';
export const progressFilterConditions = [IS_ONE_OF, IS_NOT_ONE_OF];
//# sourceMappingURL=filters.js.map